<template>
  <div id="reset_password_page" class="rp-shell" dir="rtl">
    <div class="rp-card">
      <div class="rp-logo">TOV</div>

      <div v-if="!done">
        <h2 class="rp-title">הגדרת סיסמה חדשה</h2>
        <p class="rp-sub">הזן/י סיסמה חדשה לחשבון שלך.</p>

        <div v-if="errorMsg" class="rp-banner rp-banner--error" role="alert">{{ errorMsg }}</div>

        <form @submit.prevent="submit" class="rp-form">
          <label for="rp-password" class="rp-label">סיסמה חדשה</label>
          <div class="rp-pass-wrap">
            <input
              id="rp-password"
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
              class="rp-input rp-pass-input"
              placeholder="לפחות 6 תווים"
              autocomplete="new-password"
              required
            />
            <button type="button" class="rp-pass-eye" @click="showPassword = !showPassword" :aria-label="showPassword ? 'הסתר סיסמה' : 'הצג סיסמה'">
              <svg v-if="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
            </button>
          </div>

          <label for="rp-confirm" class="rp-label">אימות סיסמה</label>
          <div class="rp-pass-wrap">
            <input
              id="rp-confirm"
              :type="showConfirm ? 'text' : 'password'"
              v-model="confirm"
              class="rp-input rp-pass-input"
              placeholder="הזן/י שוב את הסיסמה"
              autocomplete="new-password"
              required
            />
            <button type="button" class="rp-pass-eye" @click="showConfirm = !showConfirm" :aria-label="showConfirm ? 'הסתר סיסמה' : 'הצג סיסמה'">
              <svg v-if="!showConfirm" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
            </button>
          </div>

          <button type="submit" class="rp-submit" :disabled="isLoading">
            <span v-if="isLoading">שולח...</span>
            <span v-else>שמור סיסמה</span>
          </button>
        </form>
      </div>

      <div v-else class="rp-success">
        <div class="rp-success-icon">✓</div>
        <h2 class="rp-title">הסיסמה עודכנה בהצלחה!</h2>
        <p class="rp-sub">הינך מועבר/ת לאתר...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPasswordPage',

  data() {
    return {
      password: '',
      confirm: '',
      errorMsg: '',
      isLoading: false,
      done: false,
      showPassword: false,
      showConfirm: false,
    };
  },

  computed: {
    token() {
      return this.$route.query.token || '';
    },
  },

  mounted() {
    if (!this.token) {
      this.errorMsg = 'קישור לא תקין. אנא בקש/י איפוס סיסמה מחדש.';
    }
  },

  methods: {
    submit() {
      this.errorMsg = '';

      if (!this.token) {
        this.errorMsg = 'קישור לא תקין. אנא בקש/י איפוס סיסמה מחדש.';
        return;
      }
      if (this.password.length < 6) {
        this.errorMsg = 'הסיסמה חייבת להכיל לפחות 6 תווים.';
        return;
      }
      if (this.password !== this.confirm) {
        this.errorMsg = 'הסיסמאות אינן תואמות.';
        return;
      }

      this.isLoading = true;
      this.api_call({
        url: 'password_reset_confirm',
        data: { token: this.token, new_password: this.password },
        onComplete: (res) => {
          this.isLoading = false;
          const payload = res && res.data && res.data.data;
          if (payload && payload.success) {
            if (payload.user_token) {
              localStorage.setItem('user_token', payload.user_token);
            }
            this.done = true;
            setTimeout(() => {
              this.$router.push('/');
            }, 2000);
          } else if (payload && payload.reason === 'invalid_token') {
            this.errorMsg = 'הקישור אינו תקין או שפג תוקפו. אנא בקש/י איפוס סיסמה מחדש.';
          } else if (payload && payload.reason === 'invalid_input') {
            this.errorMsg = 'הסיסמה חייבת להכיל לפחות 6 תווים.';
          } else {
            this.errorMsg = 'אירעה שגיאה. אנא נסה/י שוב.';
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.rp-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  padding: var(--space-4);
}

.rp-card {
  width: 100%;
  max-width: 420px;
  background: var(--color-surface2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg, 16px);
  padding: var(--space-10) var(--space-8);
  box-sizing: border-box;
}

.rp-logo {
  font-family: var(--font-hebrew, var(--font-sans));
  font-size: 28px;
  font-weight: 800;
  color: var(--color-accent, #e11d2a);
  text-align: center;
  margin-block-end: var(--space-6);
  letter-spacing: 2px;
}

.rp-title {
  margin: 0 0 var(--space-2) 0;
  font-family: var(--font-hebrew, var(--font-sans));
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text);
  text-align: center;
}

.rp-sub {
  margin: 0 0 var(--space-6) 0;
  color: var(--color-textMuted);
  font-size: 15px;
  text-align: center;
  line-height: 1.5;
}

.rp-banner {
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-sm);
  font-size: 15px;
  margin-block-end: var(--space-4);
  line-height: 1.5;
}

.rp-banner--error {
  background-color: rgba(224, 65, 65, 0.12);
  border: 1px solid rgba(224, 65, 65, 0.33);
  color: #ffffff;
}

.rp-form {
  display: grid;
  gap: var(--space-3);
}

.rp-pass-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.rp-pass-input {
  padding-inline-start: 44px !important;
}

.rp-pass-eye {
  position: absolute;
  inset-inline-end: 12px;
  inset-block: 0;
  margin-block: auto;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: var(--color-textMuted);
  display: flex;
  align-items: center;
  height: 32px;
  transition: color 150ms ease;
}

.rp-pass-eye:hover { color: var(--color-text); }
.rp-pass-eye:focus-visible {
  outline: 2px solid var(--color-accent);
  border-radius: 4px;
}

.rp-label {
  color: var(--color-textMuted);
  font-size: 13px;
  font-weight: 600;
  display: block;
  margin-block-end: 4px;
}

.rp-input {
  width: 100%;
  height: 52px;
  padding-inline: 14px;
  border-radius: var(--radius-sm, 8px);
  border: 1px solid var(--color-borderHi);
  background: var(--color-surface3, rgba(255,255,255,0.06));
  color: var(--color-text);
  font-size: 16px;
  font-family: var(--font-hebrew, var(--font-sans));
  box-sizing: border-box;
  transition: border-color 200ms ease, box-shadow 200ms ease;

  &:focus {
    outline: none;
    border-color: var(--color-accent);
    box-shadow: 0 0 0 4px rgba(225, 29, 42, 0.18);
  }
}

.rp-submit {
  width: 100%;
  height: 52px;
  background: var(--color-accent, #e11d2a);
  color: #fff;
  border: none;
  border-radius: var(--radius-sm, 8px);
  font-size: 16px;
  font-weight: 700;
  font-family: var(--font-hebrew, var(--font-sans));
  cursor: pointer;
  margin-block-start: var(--space-2);
  transition: background 150ms ease;

  &:hover:not(:disabled) {
    background: #c8111f;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.rp-success {
  text-align: center;
  padding-block: var(--space-4);
}

.rp-success-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(90, 200, 90, 0.15);
  border: 2px solid rgba(90, 200, 90, 0.5);
  color: #6ecc6e;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--space-4);
}
</style>
